import { Component, OnInit } from '@angular/core';
import {Inject} from '@angular/core';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectMaterial } from 'src/app/objects/Project';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterPipe } from '../../filter.pipe'; // Import your custom filter pipe
import { GlobalService } from '../../global-service.service';

@Component({
  selector: 'app-project-material-add',
  templateUrl: './project-material-add.component.html',
  styleUrls: ['./project-material-add.component.css']
})
export class ProjectMaterialAddComponent implements OnInit {

  availableMaterials!: MatTableDataSource<Materials>;
  ProjectId: number | undefined ;
  project: Project |any;
  searchTerm: string = '';
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 

  items: any[] = [];
  materials: Materials []=[];
  // ProjectMaterials: ProjectMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  ProjectObject?: Project []=[];
  purchaseStage!: ['Waiting', 'Partial', 'Complete'];
 
  displayedColumns: string[] = ['Name', 'Category', 'Category', 'Description','Price'];
  durationInSeconds = 5;
  isMobile= false; 

  filteredData: Materials[];
  constructor( private route: ActivatedRoute,  private router: Router,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,private globalService: GlobalService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ProjectMaterialAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
    ) {  
     } 

  ngOnInit(): void {
 
    this.globalService.isMobile$.subscribe((value) => {
      this.isMobile = value;
    });

    if (this.data != undefined) {
       this.loadProject(this.data.projectId);
    }
    this.loadMaterials();
  }

  

 

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredData = this.materials.filter(item => {
      return Object.values(item).some(val => 
        String(val).toLowerCase().includes(filterValue)
      );
    });
  }


  loadMaterials() {
    this.materialsService.GetMaterials().subscribe((materials) => {
      this.materials = materials;
      this.filteredData = materials;
      console.log(materials);
      
    });
  }

  addMaterialToProjectMaterials(material:Materials)
  {
    let newProjectMaterial: ProjectMaterial  = Object.assign(material);
    let newProject: Project   = Object.assign({}, this.project); 

    //Go Back and Fix
   newProjectMaterial.id = 0 ; //= newProject.id;
    newProjectMaterial.productCategory = material.productCategory;
    newProjectMaterial.productDescription = material.productDescription;
    newProjectMaterial.productName = material.productName;
    newProjectMaterial.productPrice = material.productPrice;
    newProjectMaterial.productWeight = material.productWeight;
    newProjectMaterial.subCategory = material.subCategory; 
    newProjectMaterial.qty = 5;
    newProjectMaterial.cost = material.productPrice * newProjectMaterial.qty;
     //console.log(this.name,this.empoloyeeID);
   
  //  newProject.materials = newProject.materials || [];
    //  if(newProject.ProjectMaterial == null)
    // {
    //     this.ProjectMaterials.fill(newProjectMaterial);
  
    // }  
    newProject.materials.push(newProjectMaterial);
    newProject.totalProjectPrice = this.getTotalCost(newProject);
  
    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        // Simple message.
        this.openSnackBar();
        this.isLoadingResults = false;
        console.log('Project edited successfully!');
        this.loadProject(this.project?.id);
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }

  openSnackBar() {
    this.snackBar.open('Successfully Added Material To Project');
  }
 
  getTotalCost(newProject: Project)
  {
  
    const sum = newProject.materials.reduce((accumulator, object) => {
      return accumulator + object.cost;
    }, 0);
    return sum;
  }

  loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project;
     
        
    });
 
  }

  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}


  sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}
}
